<template>
    <div  :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}" style="margin-top: 6px; opacity: 0.2">
      <feather-icon icon="SquareIcon" svgClasses="h-6 w-6 cursor-none"></feather-icon>
    </div>
</template>

<script>
export default {
  name: 'CellRendererCheckbox',
  data(){
      return{}
  }
}
</script>